module.exports = __webpack_public_path__ + "img/cruk_logo.d3949e25.jpg";